import { ABMGenerico } from "src/general_components/ABMGenerico";

export const MenuFuncionalidades = ({ id_menu }) => {
    const modelo = "menu_funcionalidad";

    const condiciones = [
        { propiedad: "id_menu", valor: id_menu, operador: "=" }
    ]

    const valuesDefaultForm = { id_menu: id_menu.toString() };

    return (
        <>
            <ABMGenerico modelo={modelo} titulo={"Funcionalidades"}  condiciones={condiciones} valuesDefaultForm={valuesDefaultForm} />

        </>
    );
};
